const colors = {
  deepSapphire: '#062D60',
  electricBlue: '#0A5AC2',
  midnightBlue: '#084491',
  oceanGreen: '#3FA684',
  opalFlame: '#EB5747',
  yolkYellow: '#FCD269',
  sunrayGold: '#D2A764',
  eerieBlack: '#000000',
  cyberSpace: '#44474F',
  slateGrey: '#5A5E68',
  tulleGrey: '#8E9198',
  lunarRays: '#CACDD2',
  littleDipper: '#E4E6E9',
  athensGrey: '#F0F1F4',
  ghostWhite: '#F7F8FA',
  white: '#FFFFFF',
};

export default colors;
